
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api/axiosInstance';
import { getToken, setToken } from '../../utils/secureStorage';
const token = getToken('transactionalToken');

const Login = ({status}) => {
    const [otp, setOtp] = useState('');
    const [proceeding, setProceeding] = useState(null);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const handleOtp = async (e) => {
        e.preventDefault();
        setProceeding(true)
        try {
            const response = await api.post('/moderator/login/email/otp', { otp }, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response.data.error) {
                setError(response.data.message);
                console.log(error);
            } else {
                setToken('accessToken', response.data.accessToken);
                setToken('refreshToken', response.data.refreshToken);
                setToken('roles', response.data.roles);
                if (status === 'pending') {
                    navigate('/setpassword');
                }else{
                    navigate('/Marketing');
                }
                
            }
        } catch (err) {
            setError('Login failed. Please try again.');
        }
    };

    return (
        <div className="flex flex-col items-center justify-center px-6 pt-8 mx-auto md:h-screen pt:mt-0 dark:bg-gray-900">
            <a href="/" className="flex items-center justify-center mb-8 text-2xl font-semibold lg:mb-10 dark:text-white">
                <img src="/logo.png" className="mr-4 h-11" alt="BR DLH  Engage Logo" />
            </a>

            <div className="w-full bg-white rounded-lg shadow md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800">
                <div className="w-full p-6 sm:p-8">
                    <h2 className="mb-3 text-2xl font-bold text-gray-900 dark:text-white">
                        Login
                    </h2>
                    <form className="mt-8 space-y-6" method='post' onSubmit={handleOtp}>
                        <div>
                            <label for="otp" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">OTP</label>
                            <input value={otp} onChange={(e) => setOtp(e.target.value)} type="number" name="otp" id="otp" className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-gray-500 focus:border-gray-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-gray-500 dark:focus:border-gray-500" required="" />
                        </div>
                        <div className="flex items-start">
                            <button type='submit' className="text-white mr-auto bg-gray-700 hover:bg-gray-800 focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-md px-5 py-2.5 text-center inline-flex items-center dark:bg-gray-600 dark:hover:bg-gray-700 dark:focus:ring-gray-800">
                                {proceeding ? (<>
                                    <div className='inline mr-3' role="status">
                                        <svg aria-hidden="true" className="w-5 h-5 inline text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" /><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" /></svg>
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </>) : (<></>)} Submit
                            </button>

                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;
